import React from 'react';
// Components
import Navbar from '../../../components/nav/Navbar';
import ContactFormAdminPageMainContainer from '../../../components/contact/admin/ContactFormAdminPageMainContainer';

function ContactFormAdminPage() {
  return (
    <>
      {/* Document-level semantic wrapper */}
      <div
        className='grid min-h-screen overflow-hidden bg-colour2 dark:bg-colour2 text-colour1 dark:text-colour1 w-full h-full font-poppins'
        role='document'
        aria-label='Admin Contact Form Page'
      >
        <div className='grid grid-rows-reg'>
          {/* Navigation */}
          <Navbar />

          {/* Main content */}
          <ContactFormAdminPageMainContainer />
        </div>
      </div>
    </>
  );
}

export default ContactFormAdminPage;
